export default __webpack_public_path__ + "106828c6627f3297a2200ccc7cbf1c02.png";